import { useTranslation } from 'react-i18next';

import type { CardJobSummary } from '../../../api/cards';

/** Pre-flight batches left awaiting review, offered for re-entry. */
export function PendingReviewBanner({
  jobs,
  onResume,
}: {
  jobs: CardJobSummary[];
  onResume: (jobId: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="mb-4 space-y-2 border border-blue bg-blue/5 px-4 py-3">
      <p className="text-xs font-medium text-ink">
        {t('cardGenerator.pendingReview.title', { count: jobs.length })}
      </p>
      {jobs.map((job) => (
        <div
          key={job.jobId}
          className="flex items-center justify-between gap-3"
        >
          <span className="mono text-xs text-muted">
            {t('cardGenerator.pendingReview.batch', {
              total: job.total,
              time: new Date(job.createdAt).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
              }),
            })}
          </span>
          <button
            type="button"
            onClick={() => onResume(job.jobId)}
            className="btn-blue px-[10px] py-[4px] text-[11px]"
          >
            {t('cardGenerator.pendingReview.resume')}
          </button>
        </div>
      ))}
    </div>
  );
}
